/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["canUpgradeHeroes"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    priority: -1,
    filter: function () {
        return match3.heroes.available() && cleverapps.forces.isShown(Forces.HEROES_AVAILABLE) && match3.heroes.canUpgradeSomebody();
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "CanUpgradeHeroWindow",
            action: function (f) {
                new CanUpgradeHeroWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    interval: "10 minutes",
    delayFromStart: "10 seconds"
};
